"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const prop_types_1 = __importDefault(require("prop-types"));
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const Button_1 = __importDefault(require("components/design-system/Button"));
const LoadingIndicator_1 = __importDefault(require("components/shared/LoadingIndicator/LoadingIndicator"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
require("./ListEmptyState.scss");
const TextCompiler = ({ className, text }) => {
    const textResult = text.split('\n').map((str) => (react_1.default.createElement("p", { key: 'compiler-' + str, className: className }, str)));
    return react_1.default.createElement(react_1.default.Fragment, null, textResult);
};
const ListEmptyState = ({ datacy = 'list-empty-state', size = 'large', // According to the guidelines, there are two sizes, namely small and large
title = '', subtitle, listItem = [], fullHeight = false, containerClassname = '', titleClassname = '', subtitleClassname = '', listItemClassname, imgSrc, emptyIcon, fillIcon, btnText = '', onClick, iconBtn = '', withLoadingIndicator = false, extraElementBelow, extraElementAbove }) => {
    const containerCN = (0, classnames_template_literals_1.default)(`
    list-empty-state
    fade-in
    ${fullHeight && 'full-height'}
    ${containerClassname}
  `);
    const titleCN = (0, classnames_template_literals_1.default)(`
    text-n-900
    ${size == 'large' ? 'typography-h700' : 'typography-h500'}
    ${titleClassname}
    mb-[8px]
  `);
    const subtitleCN = (0, classnames_template_literals_1.default)(`
    text-n-800
    typography-paragraph
    text-center
    ${subtitleClassname}
  `);
    const listItemCN = (0, classnames_template_literals_1.default)(`
    text-n-800
    typography-paragraph
    text-left mt-[12px]
    ${listItemClassname}
  `);
    return (react_1.default.createElement("div", { "data-cy": datacy, className: containerCN },
        extraElementAbove && extraElementAbove,
        imgSrc && react_1.default.createElement(AWSImage_1.default, { src: imgSrc }),
        emptyIcon && (react_1.default.createElement(SVGIcon_1.default, { iconName: emptyIcon, size: size == 'large' ? 160 : 80, customClass: "mb-[24px]", fillColor: fillIcon ? fillIcon : undefined })),
        withLoadingIndicator && react_1.default.createElement(LoadingIndicator_1.default, { customClass: "mb-[30px]" }),
        title && react_1.default.createElement(TextCompiler, { text: title, className: titleCN }),
        subtitle && react_1.default.createElement(TextCompiler, { text: subtitle, className: subtitleCN }),
        listItem.length > 0 && (react_1.default.createElement("div", { className: listItemCN }, listItem === null || listItem === void 0 ? void 0 : listItem.map((item, index) => (react_1.default.createElement("div", { key: index },
            "\u2022 ",
            item.item))))),
        btnText && (react_1.default.createElement(Button_1.default, { customClass: "mt-[24px]", onClick: onClick },
            iconBtn && (react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-100)", iconName: iconBtn, customClass: "mr-[4px]" })),
            btnText)),
        extraElementBelow && extraElementBelow));
};
const Interface = {
    title: prop_types_1.default.string,
    subtitle: prop_types_1.default.string,
    fullHeight: prop_types_1.default.bool
};
ListEmptyState.propTypes = Interface;
exports.default = ListEmptyState;
